import SMSContainter from "@ui/features/SMS/SMS.container";
import React from "react";

const SMSPage: React.FC = () => {
    return (
        <>
            <SMSContainter/>
        </>
    )
}

export default SMSPage;